var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("apiLog.BoxWrap.manage") } }, [
        _c(
          "div",
          { attrs: { slot: "header-right" }, slot: "header-right" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-search",
                },
                on: { click: _vm.searchData },
              },
              [_vm._v(_vm._s(_vm.$t("common.search")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "action-container" },
          [
            _c(
              "el-form",
              { attrs: { size: "small", inline: "", "label-position": "top" } },
              [
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apiLog.input.interfaceSn"),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "apiLog.input.interfaceSnHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.interfaceSn,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "interfaceSn", $$v)
                                },
                                expression: "searchVal.interfaceSn",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("apiLog.input.errorCode") },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "apiLog.input.errorCodeHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.errorCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "errorCode", $$v)
                                },
                                expression: "searchVal.errorCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apiLog.input.detailErrorCode"),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "apiLog.input.detailErrorCodeHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.detailErrorCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchVal,
                                    "detailErrorCode",
                                    $$v
                                  )
                                },
                                expression: "searchVal.detailErrorCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("common.startDatetime") } },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                clearable: "",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                placeholder: _vm.$t("common.selectDatetime"),
                              },
                              model: {
                                value: _vm.searchVal.startTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "startTime", $$v)
                                },
                                expression: "searchVal.startTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("common.EndDatetime") } },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                clearable: "",
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                placeholder: _vm.$t("common.selectDatetime"),
                              },
                              model: {
                                value: _vm.searchVal.endTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "endTime", $$v)
                                },
                                expression: "searchVal.endTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("apiLog.input.systemSuffix"),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请下拉选择" },
                                model: {
                                  value: _vm.searchVal.systemSuffix,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "systemSuffix", $$v)
                                  },
                                  expression: "searchVal.systemSuffix",
                                },
                              },
                              _vm._l(
                                _vm.systemSuffixOptions,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.valueName,
                                      value: item.valueCode,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("apiLog.BoxWrap.list") },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                stripe: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.tableIndex,
                  label: _vm.$t("apiLog.table.sequence"),
                  width: "80",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "interfaceSn",
                  label: _vm.$t("apiLog.table.interfaceSn"),
                  width: "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "loginCode",
                  label: _vm.$t("apiLog.table.loginCode"),
                  width: "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "ipAddr",
                  label: _vm.$t("apiLog.table.ipAddr"),
                  "min-width": "170",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "pathVariable",
                  label: "路径入参",
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "errorCode",
                  label: _vm.$t("apiLog.table.errorCode"),
                  width: "110",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "detailErrorCode",
                  label: _vm.$t("apiLog.table.detailErrorCode"),
                  width: "130",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "consumeTime",
                  label: _vm.$t("apiLog.table.consumeTime"),
                  width: "100",
                  align: "right",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("apiLog.table.action"),
                  fixed: "right",
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", {
                          staticClass: "t-square-btn t-green-btn",
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-document",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.check(scope.row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("LogDetail", {
        attrs: { "is-show": _vm.isShowDetail, form: _vm.form, lang: "apiLog" },
        on: {
          "update:isShow": function ($event) {
            _vm.isShowDetail = $event
          },
          "update:is-show": function ($event) {
            _vm.isShowDetail = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }